import { render } from "./ApplicationStep4.vue?vue&type=template&id=10e9bf66"
import script from "./ApplicationStep4.vue?vue&type=script&lang=js"
export * from "./ApplicationStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__